import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import api from "../../../services/api";

import Modal from "../../../components/modal";

export default ({ project, onDone }) => {
  const [open, setOpen] = useState(false);
  const [values, setValues] = useState({
    type: "project",
    name: "",
    amount: 0,
  });
  const [sending, setSending] = useState(false);

  const handleSubmit = async () => {
    if (!values.name) return toast.error("Missing title!");
    if (!values.amount) return toast.error("Missing amount!");
    if (values.amount <= 0) return toast.error("Amount must be greater than 0!");
    if (isNaN(values.amount)) return toast.error("Amount must be a number!");
    if (!values.startAt) return toast.error("Missing start date!");
    if (!values.endAt) return toast.error("Missing end date!");
    setSending(true);

    try {
      const obj = { ...values, projectId: project._id, projectName: project.name, projectLogo: project.logo };
      const res = await api.post("/budget", obj);
      if (!res.ok) return toast.error("Failed to create budget");

      toast.success("Budget created");
      onDone(res.data);
      setOpen(false);
    } catch (error) {
      console.error(error);
      toast.error("Failed to create budget");
    } finally {
      setSending(false);
    }
  };

  return (
    <div>
      <button className="blue-btn" onClick={() => setOpen(true)}>
        Create budget
      </button>
      <Modal isOpen={open} className="w-2/3" onClose={() => setOpen(false)}>
        <div className="px-16 py-12 space-y-8">
          <h2 className="text-xl font-semibold mb-4">Create new budget</h2>
          <div className="grid grid-cols-3 gap-4">
            <div className="space-y-2">
              <label className="block text-sm font-medium text-gray-700" htmlFor="budget-name">
                Name*
              </label>
              <input id="budget-name" value={values.name} onChange={(e) => setValues({ ...values, name: e.target.value })} placeholder="Budget name" className="input" />
            </div>
            <div className="space-y-2">
              <label className="block text-sm font-medium text-gray-700" htmlFor="budget-amount">
                Amount*
              </label>
              <input
                id="budget-amount"
                type="number"
                value={values.amount}
                onChange={(e) => setValues({ ...values, amount: e.target.value })}
                placeholder="Enter amount"
                className="input"
              />
            </div>
            <div className="space-y-2">
              <label className="block text-sm font-medium text-gray-700" htmlFor="budget-type">
                Budget Type
              </label>
              <select id="budget-type" className="input w-full" value={values.type || ""} onChange={(e) => setValues({ ...values, type: e.target.value })}>
                <option value="">Select budget type</option>
                <option value="project">Project</option>
                <option value="overbudget">Overbudget</option>
                <option value="admin">Admin</option>
              </select>
            </div>
            <div className="col-span-1 space-y-2">
              <label className="block text-sm font-medium text-gray-700" htmlFor="budget-startAt">
                Start Date
              </label>
              <input
                id="budget-startAt"
                className="input w-full"
                type="date"
                value={values.startAt ? values.startAt.split("T")[0] : ""}
                onChange={(e) => setValues({ ...values, startAt: e.target.value })}
              />
            </div>
            <div className="col-span-1 space-y-2">
              <label className="block text-sm font-medium text-gray-700" htmlFor="budget-endAt">
                End Date
              </label>
              <input
                id="budget-endAt"
                className="input w-full"
                type="date"
                value={values.endAt ? values.endAt.split("T")[0] : ""}
                onChange={(e) => setValues({ ...values, endAt: e.target.value })}
              />
            </div>
          </div>
          <div className="mt-6 flex justify-end">
            <button className="gray-btn mr-2" onClick={() => setOpen(false)}>
              Cancel
            </button>
            <button disabled={sending} className="blue-btn disabled:opacity-50" onClick={handleSubmit}>
              Create
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
};
